import Highcharts from "highcharts";

Highcharts.setOptions({
  lang: {
    loading: "Carregando..."
  },
  loading: {
    labelStyle: {
      fontFamily: "Trebuchet MS",
      fontSize: "21px",
      color: "#60656C"
    }
  }
});
